/**
 * General error codes that apply across different phases
 */
enum GeneralErrorCodes {
  invalidType = 'invalid-type',
  invalidValue = 'invalid-value',
  valueRequired = 'value-required',
  nullNotAllowed = 'null-not-allowed',
  definitionsRequired = 'definitions-required',
  expectedObject = 'expected-object',
  expectedArray = 'expected-array'
}

export default GeneralErrorCodes